import update from 'immutability-helper';
import {
  FETCH_CITY_AUTOCOMPLETE,
  FETCH_CITY_AUTOCOMPLETE_SUCCESS,
  FETCH_CITY_AUTOCOMPLETE_FAIL,
  CLEAR_CITY_AUTOCOMPLETE,
} from './../actions/action_types';

export default (
  state = {
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_CITY_AUTOCOMPLETE:
      return state;
    case FETCH_CITY_AUTOCOMPLETE_SUCCESS:
      return handleAutoCompleteSuccess(state, action.payload.results);
    case FETCH_CITY_AUTOCOMPLETE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CLEAR_CITY_AUTOCOMPLETE:
      return update(state, {
        data: { $set: [] },
        error: { $set: null },
      });
    default:
      return state;
  }
};

const handleAutoCompleteSuccess = (state, results) => {
  const data = [...results];
  const newState = update(state, {
    data: { $set: data },
    error: { $set: null },
  });
  return newState;
};
